import { DashboardConfig } from "./common/components/dashboard/dashboard-config";
import { AvverkningListComponent } from "./common/components/dashboard/widgets/avverkning-list/avverkning-list.component";
import { PagaendeAffarerComponent } from "./common/components/dashboard/widgets/pagaende-affarer/pagaende-affarer.component";
import { InsiktenReportsComponent } from "./common/components/dashboard/widgets/rotstaende-lager/insikten-reports.component";
import { SkogsvardListaComponent } from "./common/components/dashboard/widgets/skogsvard-lista/skogsvard-lista.component";
import { WelcomeSectionComponent } from "./common/components/dashboard/widgets/welcome-section/welcome-section.component";

export const RaskDashboardConfig: DashboardConfig = {
    widgets: {
        pagaendeAffarer: PagaendeAffarerComponent,
        skogsvardLista: SkogsvardListaComponent,
        insiktenReports: InsiktenReportsComponent,
        welcomeSection: WelcomeSectionComponent,
        avverkningList: AvverkningListComponent
    },
    cellGap: 8,
    columns: 4,
    rows: 12,
    // Hårdkodad data. När det finns stöd för att spara användarens dashboard så ska denna data hämtas därifrån.
    data: [
        {
            dimensions: {
                row: 0,
                column: 0,
                width: 4,
                height: 1
            },
            id: "welcomeWidget",
            component: "welcomeSection"
        },
        {
            dimensions: {
                row: 1,
                column: 0,
                width: 1,
                height: 11
            },
            id: "widget1",
            component: "insiktenReports"
        },
        {
            dimensions: {
                row: 1,
                column: 1,
                width: 1,
                height: 11
            },
            id: "widget2",
            component: "pagaendeAffarer"
        },
        {
            dimensions: {
                row: 1,
                column: 2,
                width: 1,
                height: 11
            },
            id: "widget3",
            component: "avverkningList"
        },
        {

            dimensions: {
                row: 1,
                column: 3,
                width: 1,
                height: 11
            },
            id: "widget4",
            component: "skogsvardLista"
        }
    ]
};
